import { baseApiUrl, domainName } from '@/utils/common/env.constants';
import { IOnlineDegreeListingPayload } from '@/interfaces/degreeListingPage';
import { domainNameEnums, saasDomains } from '@/utils/Domain';
import { saasDomainprefixUrl, skillsDomainprefixUrl } from '@/utils/Configuration/utils';
import { ICourseEnquiry } from '../interfaces/courseDescription';
import { get, post } from './index';

const prefixUrl = saasDomains.includes(domainName as domainNameEnums)
  ? saasDomainprefixUrl
  : skillsDomainprefixUrl;
class OnlineDegreePageApi {
  static getPartnerInstitutesData() {
    return get('/partnerInstitute/fetch-all');
  }

  static async onlineDegreeEnquiry(
    // categoryPageId: string,
    token: string,
    data: {
      fullName: string;
      email?: string;
      isdCode: string;
      phoneNumber: string;
      field_student_background?: string | undefined;
      field_work_experience?: string | undefined;
      field_course_type?: string | undefined;
    }
  ) {
    return post<ICourseEnquiry>(
      `course/sendOnlineDegreeLeadToLeadSquared`,
      {
        ...data,
        'g-recaptcha-response': token,
      },
      undefined,
      `${baseApiUrl}/${prefixUrl}`
    );
  }

  static async onlineDegreeCourses(data: IOnlineDegreeListingPayload) {
    return post<any>(
      `course/online-degree`,
      {
        ...data,
      },
      undefined,
      `${baseApiUrl}/v2`
    );
  }

  static async getInstituteDegreeList(
    isInstituteList: boolean,
    isPremium: boolean,
    isDegreeList: boolean
  ) {
    return get<any>(
      `online-degree/institute-degree?${
        isInstituteList ? `instituteList=${isInstituteList}&` : ''
      }premium=${isPremium}${isDegreeList ? `&degreeList=${isDegreeList}` : ''}`,
      undefined,
      `${baseApiUrl}/v2`
    );
  }
}

export default OnlineDegreePageApi;
